var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElSalvador(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1c44a6",
    d: "M0 24V0h30v24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 8h30v8H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c44a6",
    d: "M14.43 11.3 13.27 10s-.19 2.4.17 2.97z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c44a6",
    d: "m14.13 12.23-1.53-1s-.13 1.8.54 2.07zm1.44-.93 1.16-1.3s.19 2.4-.17 2.97z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c44a6",
    d: "m15.87 12.23 1.53-1s.13 1.8-.54 2.07z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7cf46",
    d: "M15 15.54a3.54 3.54 0 1 1 0-7.09 3.54 3.54 0 0 1 0 7.1m0-6.56a3.02 3.02 0 1 0 0 6.05 3.02 3.02 0 0 0 0-6.05"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15 9.8-2.09 3.62h4.18z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7cf46",
    d: "M17.54 13.68h-5.08L15 9.28zm-4.18-.52h3.28L15 10.33z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElSalvador);
export default __webpack_public_path__ + "static/media/el-salvador.5c65a7c55dfb16b4ad73053953b6c48d.svg";
export { ForwardRef as ReactComponent };